import { jetSetCatalog } from './jet-set-data.js';

export type PrimitiveKind = 'prop' | 'ground' | 'ui';
export type PrimitiveView = { path: string; width: number; height: number; anchor: [number, number]; bounds: [number, number, number, number]; topLift?: number };
export type PrimitiveAsset = { id: string; kind: PrimitiveKind; status: 'ready' | 'placeholder'; reviewStatus: string; reason?: string; model?: string | null; views: PrimitiveView[] };
export const primitiveCatalog: Record<string, PrimitiveAsset> = jetSetCatalog;
const placeholder: PrimitiveAsset = {
    id: 'missing', kind: 'prop', status: 'placeholder', reviewStatus: 'pending', reason: 'Unknown primitive',
    views: [{ path: '/assets/art/jet-set/placeholder.svg', width: 256, height: 256, anchor: [128, 220], bounds: [24, 28, 232, 240] }],
};

export function directionIndex(camera: number, turn = 0) {
    if (!Number.isInteger(camera) || !Number.isInteger(turn)) throw new Error('Camera and object turns must be whole quarters');
    return ((camera + turn) % 4 + 4) % 4;
}

export function resolvePrimitive(id: string, camera = 0, turn = 0) {
    const asset = Object.prototype.hasOwnProperty.call(primitiveCatalog, id) ? primitiveCatalog[id] : placeholder;
    const view = asset.views[asset.views.length === 4 ? directionIndex(camera, turn) : 0];
    return { ...asset, view };
}

export function validatePrimitive(asset: PrimitiveAsset) {
    if (asset.kind === 'prop' && asset.status === 'ready' && asset.views.length !== 4) return 'A ready prop needs four views';
    if (!asset.views.length) return 'An asset needs a view or placeholder';
    for (const view of asset.views) {
        if (!view.path || ![view.width, view.height, ...view.anchor, ...view.bounds].every(Number.isFinite)) return 'Invalid image geometry';
        if (view.width <= 0 || view.height <= 0) return 'Invalid image dimensions';
        if (view.anchor[0] < 0 || view.anchor[0] > view.width || view.anchor[1] < 0 || view.anchor[1] > view.height) return 'Anchor outside image';
        const [left, top, right, bottom] = view.bounds;
        if (left < 0 || top < 0 || right > view.width || bottom > view.height || left >= right || top >= bottom) return 'Invalid visible bounds';
    }
    return undefined;
}
